import Http from '@/app-core/lib/data/api/Http'

export default {
  Otp: {
    Get: {
      Path  : 'auth/otp',
      Method: Http.Method.Post
    },
    Validate: {
      Path  : 'auth/otp/validate',
      Method: Http.Method.Post
    }
  },

  Contact: {
    Send: {
      Path  : 'contact/send',
      Method: Http.Method.Post
    }
  },

  Config: {
    Get: {
      Path  : 'config',
      Method: Http.Method.Get
    }
  },

  Rating: {
    Rate: {
      Path  : 'rating/send',
      Method: Http.Method.Post
    },
    Get: {
      Path  : 'rating',
      Method: Http.Method.Post
    }
  },

  Account: {
    Details: {
      Path  : 'account/details',
      Method: Http.Method.Post
    },
    Orders: {
      Path  : 'account/orders',
      Method: Http.Method.Post
    },
    Address: {
      Save: {
        Path  : 'account/address',
        Method: Http.Method.Post
      },
      Delete: {
        Path  : 'account/address/delete',
        Method: Http.Method.Post
      },
      Validate: {
        Path  : 'address/validate',
        Method: Http.Method.Post
      }
    },
    Delete: {
      Path  : 'account/delete',
      Method: Http.Method.Post
    },
    Export: {
      Path  : 'account/export',
      Method: Http.Method.Post
    },
    Pin: {
      Path  : 'account/pin',
      Method: Http.Method.Post
    }
  },

  Checkout: {
    Payment: {
      Path  : 'checkout/payment',
      Method: Http.Method.Post
    },
    Success: {
      Path  : 'checkout/success',
      Method: Http.Method.Post
    },
    Failure: {
      Path  : 'checkout/failure',
      Method: Http.Method.Post
    }
  },

  Cart: {
    Get: {
      Path  : 'cart',
      Method: Http.Method.Get
    },
    Add: {
      Path  : 'cart/add',
      Method: Http.Method.Post
    },
    Remove: {
      Path  : 'cart/remove',
      Method: Http.Method.Post
    },
    Update: {
      Path  : 'cart/update',
      Method: Http.Method.Post
    },
    Scheduled: {
      Path  : 'cart/scheduled',
      Method: Http.Method.Post
    },
    OrderType: {
      Path  : 'cart/order-type',
      Method: Http.Method.Post
    },
    Options: {
      Path  : 'cart/options/{storeId}/{productId}/{rowId}',
      Method: Http.Method.Get
    },
    Coupon: {
      Path  : 'cart/coupon',
      Method: Http.Method.Post
    },
    Charge: {
      Path  : 'cart/charge',
      Method: Http.Method.Post
    }
  },

  Store: {
    Menu: {
      Path  : 'menu/{storeId}',
      Method: Http.Method.Get
    }
  },

  Tag: {
    Menu: {
      Path  : 'tag/{tagId}',
      Method: Http.Method.Get
    }
  },

  User: {
    Login: {
      Path  : 'auth/login',
      Method: Http.Method.Post
    },
    Logout: {
      Path  : 'auth/logout',
      Method: Http.Method.Post
    },
    ResetPassword: {
      Path  : 'auth/reset',
      Method: Http.Method.Post
    },
    AuthStatus: {
      Path  : 'auth/status',
      Method: Http.Method.Post
    },
    Register: {
      Path  : 'auth/register',
      Method: Http.Method.Post
    },
    AuthGoogle: {
      Path  : 'auth/google',
      Method: Http.Method.Post
    },
    AuthFacebook: {
      Path  : 'auth/facebook',
      Method: Http.Method.Post
    }
  }
}
